/*
  Component: Announcement bar — message slider
  Responsibility: hand over from one message block to the next on a timer, by moving a
                  state class. Layout and the cross-fade belong to the stylesheet.

  Everything lives inside one IIFE. Both announcement bar files are ordinary <script src>
  tags, which share a single global scope — two files each declaring their own
  MILLISECONDS_PER_SECOND at the top level is a SyntaxError that kills whichever loads
  second. The wrapper is what keeps these names this file's own.
*/
(function initAnnouncementBarSliderModule() {
  const ACTIVE_CLASS = 'is-active';
  const DEFAULT_INTERVAL_SECONDS = 5;
  const MILLISECONDS_PER_SECOND = 1000;

  function getNextIndex(currentIndex, slideCount) {
    return (currentIndex + 1) % slideCount;
  }

  function getIntervalMilliseconds(intervalText) {
    const intervalSeconds = Number.parseFloat(intervalText);

    if (!Number.isFinite(intervalSeconds) || intervalSeconds <= 0) {
      console.debug('Announcement bar slider: unreadable interval, using the default', {
        intervalText,
      });

      return DEFAULT_INTERVAL_SECONDS * MILLISECONDS_PER_SECOND;
    }

    return intervalSeconds * MILLISECONDS_PER_SECOND;
  }

  function getActiveIndex(slides) {
    const activeIndex = slides.findIndex((slide) => slide.classList.contains(ACTIVE_CLASS));

    return activeIndex === -1 ? 0 : activeIndex;
  }

  function initAnnouncementBarSlider(bar) {
    const slider = bar.querySelector('[data-kl-announcement-bar-slider]');
    const countdown = bar.querySelector('[data-kl-announcement-bar-countdown]');

    bar.classList.toggle('has-countdown', Boolean(countdown));

    if (!slider) {
      bar.classList.add('is-first-slide');
      return;
    }

    const slides = Array.from(slider.querySelectorAll('[data-kl-announcement-bar-slide]'));

    if (slides.length < 2) {
      bar.classList.add('is-first-slide');
      return;
    }

    const intervalMilliseconds = getIntervalMilliseconds(slider.dataset.klAnnouncementBarInterval);

    let currentIndex = getActiveIndex(slides);
    let intervalId = 0;
    let isHeld = false;

    // The first slide can be left unmarked by the markup; make the state explicit either way.
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle(ACTIVE_CLASS, slideIndex === currentIndex);
    });
    bar.classList.toggle('is-first-slide', currentIndex === 0);

    const showNextSlide = () => {
      if (!slider.isConnected) {
        clearInterval(intervalId);
        return;
      }

      if (isHeld) return;

      const nextIndex = getNextIndex(currentIndex, slides.length);

      slides[currentIndex].classList.remove(ACTIVE_CLASS);
      slides[nextIndex].classList.add(ACTIVE_CLASS);
      currentIndex = nextIndex;
      bar.classList.toggle('is-first-slide', currentIndex === 0);
    };

    const holdCurrentSlide = () => {
      isHeld = true;
    };

    const releaseCurrentSlide = () => {
      isHeld = false;
    };

    bar.addEventListener('mouseenter', holdCurrentSlide);
    bar.addEventListener('mouseleave', releaseCurrentSlide);
    bar.addEventListener('focusin', holdCurrentSlide);
    bar.addEventListener('focusout', releaseCurrentSlide);

    intervalId = setInterval(showNextSlide, intervalMilliseconds);
  }

  function initAnnouncementBarSliders(root) {
    root.querySelectorAll('[data-kl-announcement-bar]').forEach((bar) => {
      try {
        initAnnouncementBarSlider(bar);
      } catch (error) {
        console.debug('Announcement bar slider failed to start', { error });
      }
    });
  }

  initAnnouncementBarSliders(document);

  // Theme editor: a re-rendered section arrives with fresh, uninitialised markup.
  document.addEventListener('shopify:section:load', (event) => {
    initAnnouncementBarSliders(event.target);
  });
})();
